import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoadDistributionForm } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { LoadDistributionFormValues } from "../../../types";
import {
  LOAD_DISTRIBUTION_AFTER_WEIGHING_FIELD,
  LOAD_DISTRIBUTION_CALCULATION_FIELDS,
  LOAD_DISTRIBUTION_DRIVER_WALL_FIELDS,
  LOAD_DISTRIBUTION_SECTION_KEYS,
  LOAD_DISTRIBUTION_WEIGHING_COMMENTS_FIELD,
  LOAD_DISTRIBUTION_WEIGHING_ROW1_FIELDS,
} from "../data";
import { FormFieldControl, FormSection } from "../VehicleDetails/FormControls";
import { useStyles } from "./styles";

const LoadForm = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const formValues = useSelector(selectLoadDistributionForm);

  const updateField = (field: keyof LoadDistributionFormValues, value: string | boolean) => {
    dispatch(actions.updateLoadDistributionFormField({ field, value: String(value) }));
  };

  if (!formValues) {
    return null;
  }

  const fieldClassNames = {
    wrapperClassName: styles.field,
    labelClassName: styles.label,
    inputClassName: styles.input,
    selectClassName: styles.select,
    selectValueClassName: styles.selectValue,
    selectPlaceholderClassName: styles.selectPlaceholder,
    selectControlClassName: styles.selectControl,
    selectIconComponent: KeyboardArrowDownIcon,
    replaceInputStyles: true,
  };

  return (
    <>
      <FormSection titleKey={LOAD_DISTRIBUTION_SECTION_KEYS.CALCULATION_DATA} hideTopBorder>
        <Box className={styles.grid3}>
          {LOAD_DISTRIBUTION_CALCULATION_FIELDS.map((config) => (
            <FormFieldControl
              key={String(config.field)}
              config={config}
              value={formValues[config.field]}
              onChange={(value) => updateField(config.field, value)}
              {...fieldClassNames}
            />
          ))}
        </Box>
      </FormSection>

      <FormSection titleKey={LOAD_DISTRIBUTION_SECTION_KEYS.CHASSIS_WEIGHING} hideTopBorder>
        <Box className={styles.sectionFields}>
          <Box className={styles.grid4}>
            {LOAD_DISTRIBUTION_WEIGHING_ROW1_FIELDS.map((config) => (
              <FormFieldControl
                key={String(config.field)}
                config={config}
                value={formValues[config.field]}
                onChange={(value) => updateField(config.field, value)}
                {...fieldClassNames}
              />
            ))}
          </Box>
          <Box className={styles.grid2}>
            <FormFieldControl
              config={LOAD_DISTRIBUTION_AFTER_WEIGHING_FIELD}
              value={formValues.afterWeighingData}
              onChange={(value) => updateField("afterWeighingData", value)}
              {...fieldClassNames}
            />
            <FormFieldControl
              config={LOAD_DISTRIBUTION_WEIGHING_COMMENTS_FIELD}
              value={formValues.weighingComments}
              onChange={(value) => updateField("weighingComments", value)}
              {...fieldClassNames}
            />
          </Box>
        </Box>
      </FormSection>

      <FormSection titleKey={LOAD_DISTRIBUTION_SECTION_KEYS.DRIVER_WALL_AUTO} hideTopBorder>
        <Box className={styles.grid3}>
          {LOAD_DISTRIBUTION_DRIVER_WALL_FIELDS.map((config) => (
            <FormFieldControl
              key={String(config.field)}
              config={config}
              value={formValues[config.field]}
              onChange={(value) => updateField(config.field, value)}
              {...fieldClassNames}
            />
          ))}
        </Box>
      </FormSection>
    </>
  );
};

export default LoadForm;
